import { Injectable } from '@angular/core';
import { Router, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';
import { SESSION_STORAGE, ROUTES, GLOBAL } from '../shared';
import { StorageService } from '../shared';
import { Observable } from 'rxjs';
import { Util } from '../shared';
import { recordLogoutReason } from '../shared/utils/logout-diagnostics';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard  {
  previousRoute: string;
  constructor(private router: Router, private readonly storageService: StorageService) {}

  canActivateChild(
    childRoute: ActivatedRouteSnapshot,
    state: RouterStateSnapshot):
    boolean | UrlTree | Observable<boolean | UrlTree> | Promise<boolean | UrlTree> {
    return this.canActivate(childRoute, state);
  }

  async canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Promise<boolean> {
    const token = localStorage[SESSION_STORAGE.TOKEN];
    const canActivate: boolean = !Util.isNullOrUndefined(token) && !this.tokenExpired(token);

    if (canActivate) {
      // Ensure session storage fields are populated for auto-login scenarios
      this.ensureSessionStorageFields(token);
    } else {
      //this.storageService.store(GLOBAL.PREVIOUS_URL, state.url);
      sessionStorage.setItem(GLOBAL.PREVIOUS_URL, state.url);
      // Logout diagnostics (temporary, QA): which guarded route was denied and why.
      recordLogoutReason(Util.isNullOrUndefined(token) ? 'guard: no token' : 'guard: token expired', { route: state.url });
      this.router.navigate([ROUTES.LOGIN]);
    }

    return canActivate;
  }

  private base64UrlToBase64(base64url) {
    return base64url
      .replace(/-/g, '+')
      .replace(/_/g, '/')
      .padEnd(Math.ceil(base64url.length / 4) * 4, '=');
  }

  private tokenExpired(token: string) {
    if (token != "null"){
      let split = token.split('.')
      let base64 = this.base64UrlToBase64(split[1]);
      let atobsplit = atob(base64)
      let parseAtob = JSON.parse(atobsplit)
      const expiry = parseAtob.exp;
      return (Math.floor((new Date).getTime() / 1000)) >= expiry;
    }
    else return false;
  }

  private async ensureSessionStorageFields(token: string): Promise<void> {
    // Check if essential session storage fields are missing
    const fullName = sessionStorage.getItem(SESSION_STORAGE.FULL_NAME);
    const customerId = sessionStorage.getItem(SESSION_STORAGE.CUSTOMER_ID);
    const user = sessionStorage.getItem(SESSION_STORAGE.USER);

    // If any essential fields are missing, try to populate them from stored user data
    if (!fullName || !customerId || !user) {
      try {
        // Get user data from localStorage
        const storedUser = localStorage.getItem(SESSION_STORAGE.USER);
        if (storedUser) {
          const userData = JSON.parse(atob(storedUser));

          // Populate missing session storage fields
          if (!fullName && userData.FullName) {
            sessionStorage.setItem(SESSION_STORAGE.FULL_NAME, userData.FullName);
          }
          if (!customerId && userData.CustomerId) {
            sessionStorage.setItem(SESSION_STORAGE.CUSTOMER_ID, userData.CustomerId);
          }
          if (!user && userData.id) {
            sessionStorage.setItem(SESSION_STORAGE.USER, userData.id);
          }

          // Also ensure token is in sessionStorage if needed
          if (!sessionStorage.getItem(SESSION_STORAGE.TOKEN)) {
            sessionStorage.setItem(SESSION_STORAGE.TOKEN, token);
          }
        }
      } catch (error) {
        console.warn('Failed to populate session storage fields from stored user data:', error);
      }
    }
  }
}
